import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { CountryApi } from "./ops";

export const countryKeys = {
  all: ["country"] as const,
  details: (locCode: number) => [...countryKeys.all, "details", locCode] as const,
};

export function useCountryLocCodes() {
  return useQuery({
    queryKey: countryKeys.all,
    queryFn: ({ signal }) => CountryApi.getLocCodes(signal),
  });
}

export function useCountryByLocCode(locCode: number) {
  return useQuery({
    queryKey: countryKeys.details(locCode),
    queryFn: ({ signal }) => {
      if (!locCode) throw new Error("locCode is required");
      return CountryApi.getByLocCode(locCode, signal);
    },
    enabled: !!locCode,
  });
}
